import { CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, Output, inject } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { BatchSalesReport } from "@models/batch-sales-report";
import { Page } from "@models/page";
import { SellerSalesSummary } from "@models/seller-sales-summary";
import { TableModule } from "primeng/table";
import { SellerPaymentMethodDetailsDialogComponent } from "./seller-payment-method-details-dialog.component";

type SalesSummaryTab = "batch" | "seller";

export interface SellerSalesPageChange {
  page: number;
  perPage: number;
}

interface TablePageEvent {
  first?: number;
  rows?: number;
}

@Component({
  selector: "app-batch-sales-report-table",
  imports: [CommonModule, TableModule],
  templateUrl: "./batch-sales-report-table.component.html",
  styleUrl: "./batch-sales-report-table.component.scss",
})
export class BatchSalesReportTableComponent {
  private readonly dialog = inject(MatDialog);

  @Input({ required: true }) data: BatchSalesReport[] = [];
  @Input() sellerSummaryPage: Page<SellerSalesSummary> | null = null;
  @Output() sellerPageChange = new EventEmitter<SellerSalesPageChange>();

  activeTab: SalesSummaryTab = "batch";

  setActiveTab(tab: SalesSummaryTab): void {
    this.activeTab = tab;
  }

  handleSellerPageChange(event: TablePageEvent): void {
    const perPage = event.rows ?? 5;
    const first = event.first ?? 0;
    this.sellerPageChange.emit({
      page: Math.floor(first / perPage),
      perPage,
    });
  }

  openSellerDetails(seller: SellerSalesSummary): void {
    this.dialog.open(SellerPaymentMethodDetailsDialogComponent, {
      width: "min(100vw - 1.5rem, 48rem)",
      maxWidth: "100vw",
      data: seller,
    });
  }
}
